var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7777 0.475159H16.8617V23.7767C14.2575 24.2693 12.3405 24.4631 10.2663 24.4631C4.05685 24.4566 0.82457 21.6826 0.82457 16.3548C0.82457 11.2215 4.25314 7.88996 9.56614 7.88996C10.3906 7.88996 11.0187 7.95484 11.7777 8.14922V0.475159ZM11.9558 12.3484C11.3604 12.154 10.8697 12.0892 10.2415 12.0892C7.67016 12.0892 6.1849 13.6576 6.1849 16.4064C6.1849 19.0827 7.6048 20.5604 10.2089 20.5604C10.7715 20.5604 11.2296 20.5287 11.9558 20.4315V12.3484Z",
    fill: "#2BA977"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1754 8.51555V20.1823C25.1754 24.2001 24.8745 26.1323 23.9911 27.7981C23.1667 29.3996 22.0806 30.4094 19.8363 31.5249L15.1187 29.3018C17.363 28.2588 18.4491 27.3372 19.1428 25.9307C19.8689 24.4925 20.0979 22.8267 20.0979 18.4452V8.51565H25.1754V8.51555ZM19.5856 0.475159H24.6696V5.64092H19.5856V0.475159Z",
    fill: "#2BA977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.5d2d4baa36cde8e34011503126f23b91.svg";
export { ForwardRef as ReactComponent };